import { useMutation } from 'react-query';
import { AxiosError } from 'axios';
import { Axios } from '@utils/api/axios-instance.ts';
import { POST_URL } from '@utils/api/endpoints.ts';
import { BaseError, BaseResponse } from '@utils/types/shared/base.ts';

type EnablePayload = {
  language_id: number;
  organization_id: number;
};

type EnabledPublication = {
  id: number;
  language_id: number;
  organization_id: number;
};

export const useEnableResellerLanguagePublication = () => {
  return useMutation<
    BaseResponse<EnabledPublication>,
    AxiosError<BaseError>,
    EnablePayload
  >(async payload => {
    const { resellerLanguagePublication } = POST_URL();
    const { data } = await Axios.post<BaseResponse<EnabledPublication>>(
      resellerLanguagePublication,
      payload
    );
    return data;
  });
};
